import { Row, RowList, Text3, TextLink } from '@telefonica/mistica';
import React, { useEffect } from 'react';
import './index.scss';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import navigateParams from '../../../../utils/navigation/navigateParams';
import { useDispatch, useSelector } from 'react-redux';
import { getUser } from '../../../../utils/store/store';
import { showStopper } from '../../../../utils/store/features/user';
import { TrackingEvents } from '../../../../utils/dataTransformation/tracking';
import { isWebviewAndroid, isWebviewIOS } from '../../../../utils/navigation/controlDevices';
const ModalSlowConnection: React.FC<{ preventLink?: boolean; onSelect?: () => void }> = ({
    preventLink = false,
    onSelect,
}) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { app } = useSelector(getUser);
    const sendToNative = (url: string, type: any, title: any) => {
        const queryParams = {};
        if (navigateParams(type, url, {}, {}, title)) {
            navigate(url);
        }
    };

    const { trackingScreenView } = new TrackingEvents();
    useEffect(() => {
        if (!(isWebviewAndroid || isWebviewIOS)) {
            trackingScreenView();
        }
    }, []);
    return (
        <div className='modalSlowConnection-page'>
            <div className='modalSlowConnection-page__title'>
                <Text3 regular>{t('slowConnectionTitle')}</Text3>
            </div>
            <div className='modalSlowConnection-page__content'>
                <RowList>
                    <Row
                        title={t('slowConnetionItemOneTitle')}
                        description={t('slowConnetionItemOneDescription')}
                        extra={
                            <TextLink
                                className='modalSlowConnection-page__content-link'
                                onPress={() => {
                                    sendToNative('/support', 'modeFlow-backgroundBlue', t('breadcrumbsSupport'));
                                }}
                            >
                                {t('slowConnetionItemOneLink')}
                            </TextLink>
                        }
                    ></Row>
                    <Row
                        title={t('slowConnetionItemTwoTitle')}
                        description={t('slowConnetionItemTwoDescription')}
                        extra={
                            <TextLink
                                className='modalSlowConnection-page__content-link'
                                onPress={() => {
                                    if (!preventLink) {
                                        sendToNative(
                                            '/fiber/fiber-modal-tips-to-improve-connection',
                                            'modeFlow-backgroundWhite',
                                            t('tipsToImproveConnection'),
                                        );
                                    } else {
                                        if (onSelect) onSelect();
                                    }
                                }}
                            >
                                {t('slowConnetionItemTwoLink')}
                            </TextLink>
                        }
                    ></Row>
                    <Row
                        title={t('slowConnetionItemThreeTitle')}
                        description={t('slowConnetionItemThreeDescription')}
                    ></Row>
                    <Row
                        title={t('slowConnetionItemFourTitle')}
                        description={t('slowConnetionItemFourDescription')}
                    ></Row>
                </RowList>
            </div>
        </div>
    );
};
export default ModalSlowConnection;
